import IBaseListingResponse from "../../utils/api/base-listing-response";
import { HttpClient, RequestParams } from "../../utils/api/http-client";
import { IBatchWriteOffQuery } from "../../models/wms/batch-write-off/query";
import { IBatchWriteOffDecisionRequest } from "../../models/wms/batch-write-off/request";
import { IBatchWriteOff } from "../../models/wms/batch-write-off/response";

const buildQuery = (query: IBatchWriteOffQuery = {}) =>
  Object.entries(query).reduce<Record<string, string | number>>(
    (current, [key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        current[key] = value as string | number;
      }
      return current;
    },
    {},
  );

class WmsBatchWriteOffService<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  getAll = (query: IBatchWriteOffQuery, params?: RequestParams) =>
    this.http.request<IBaseListingResponse<IBatchWriteOff>>({
      path: "/wms/batch-write-offs",
      method: "GET",
      query: buildQuery(query),
      ...params,
    });

  confirm = (
    id: number,
    data: IBatchWriteOffDecisionRequest,
    params?: RequestParams,
  ) =>
    this.http.request<IBatchWriteOff>({
      path: `/wms/batch-write-offs/${id}/confirm`,
      method: "PATCH",
      body: data,
      ...params,
    });

  reverse = (
    id: number,
    data: IBatchWriteOffDecisionRequest,
    params?: RequestParams,
  ) =>
    this.http.request<IBatchWriteOff>({
      path: `/wms/batch-write-offs/${id}/reverse`,
      method: "PATCH",
      body: data,
      ...params,
    });
}

export default WmsBatchWriteOffService;
